<template>
  <span ref="container" v-bind="$attrs"></span>
</template>

<script>
import { getIpCountry } from './ContactInfo.vue';

export default {
    props: {
        locale: String,
        type: String,
        flag: String,
        flags: {
            type: Object,
            default: {},
        },
    },
    async mounted () {
        const classList = this.$refs.container.classList;
        classList.add('swapping');

        let flag = null;
        try {
            flag = await this.ipContact();
        } catch (e) {
            flag = null;
        }

        if (flag && this.flag && this.flag !== flag) {
            this.$nextTick(() => {
                classList.remove('fi-' + this.flag);
                classList.add('fi-' + flag);
            });
        }
                
        this.$nextTick(() => classList.remove('swapping'));
    },

    methods: {
        async ipContact() {
            const country = await getIpCountry();
            if (!country) {
                return null;
            }

            const locale = Object.keys(this.flags).find((k) => k.endsWith(country.toUpperCase()));

            return locale ? (this.flags[locale] ?? null) : null;
        },
    }
}
</script>
